export default {
    CLOSE: "Закрыть",
    SAVE: "Сохранить",
    CANCEL: "Отменить"
};
